import script from "./JAVCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./JAVCard.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__